/**
 * @generated SignedSource<<3009e39ea34352233851bcab9fb0fb9f>>
 * @relayHash ea81c42ee88f6f6b7345d1f475afbf69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ce11c87f1d8dd20e2a8c431c2690eab2d33cb7835f0e966ed411c8a1976142ba

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionBacklogPanelRelayQuery } from './uiVersionBacklogPanelRelayQuery.graphql';

const node: PreloadableConcreteRequest<uiVersionBacklogPanelRelayQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ce11c87f1d8dd20e2a8c431c2690eab2d33cb7835f0e966ed411c8a1976142ba",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "versionsForProjects"
          ]
        }
      ]
    },
    "name": "uiVersionBacklogPanelRelayQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
